import { JsonRpcProvider } from '@ethersproject/providers';
import { usePrivy } from '@privy-io/react-auth';

import environments from '../utils/environments';

const { PUBLIC_RPC_URL } = environments;

function useWrappedRPC() {
  const { sendTransaction } = usePrivy();
  class WrappedJsonProvider extends JsonRpcProvider {
    async getCustomizedFeeData() {
      const feeData = await this.getFeeData();
      const maxPriorityFeePerGas = Math.max(Number(feeData.maxPriorityFeePerGas), 20000000000);
      const maxFeePerGas = Number(feeData.maxFeePerGas) + maxPriorityFeePerGas;
      const gasPrice = feeData.gasPrice;

      return {
        maxFeePerGas,
        maxPriorityFeePerGas,
        gasPrice,
      };
    }
  }

  const sendTransactionWithGas = async (transactionRequest, txUiConfig) => {
    const provider = new WrappedJsonProvider(PUBLIC_RPC_URL);

    const { maxFeePerGas, maxPriorityFeePerGas } = await provider.getCustomizedFeeData();

    const tx = {
      ...transactionRequest,
      maxFeePerGas,
      maxPriorityFeePerGas,
    };

    return await sendTransaction(tx, txUiConfig);
  };

  const customChainNetwork = {
    name: process.env.REACT_CHAIN_NAME,
    chainId: parseInt(process.env.REACT_APP_CHAIN_ID || '0', 10),
  };

  return { WrappedJsonProvider, sendTransactionWithGas, customChainNetwork };
}

export default useWrappedRPC;
